import { useDashboardPermissions } from '@components';
import { useAdminModeContext } from '@modules/App/providers/AdminModeProvider';
import { useProductPricing } from '@modules/Dashboard/Product/hooks/useProductPricing';
import { useVariants } from '@modules/Dashboard/Product/modules/variants/hooks/useVariants';
import { updateValuesVariantQuantity } from '@modules/Dashboard/Product/modules/variants/utils';
import { routing } from '@utils/routing';
import { useFormikContext } from 'formik';
import { reverse } from 'named-urls';
import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useOffer } from '../../hooks/useOffer';
import { useStock } from './hooks/useStock';
import { VariantsView } from './VariantsView';
export const VariantsContainer = ({ applyToAllVariants }) => {
    const adminMode = useAdminModeContext();
    const location = useLocation();
    const navigate = useNavigate();
    const { productId = '' } = useParams();
    const { hasPermission } = useDashboardPermissions();
    const { offer } = useOffer(productId);
    const { showPricingPerVariant } = useProductPricing();
    const { values, initialValues, setValues, resetForm } = useFormikContext();
    const { variants } = useVariants(values.variants, productId);
    const onStockChangeSuccess = ({ id, quantity }) => {
        // NOTE: Update initialValues to avoid confirm bar showing up
        resetForm({ values: updateValuesVariantQuantity(initialValues, id, quantity) });
        // NOTE: Update Values to keep current changes after resetting the form
        setValues(updateValuesVariantQuantity(values, id, quantity));
    };
    const { handleStockChange } = useStock({ productId, onSuccess: onStockChangeSuccess });
    const showVariantsWeight = offer.variantTypes.some((variantType) => variantType.variesBy.weight);
    const showVariantsTable = (offer.offerType === 'MANUAL' || showPricingPerVariant || !!adminMode?.isActive) &&
        variants.length >= 2;
    const viewConfig = {
        showVariantsTable,
        showPricing: showPricingPerVariant,
        showWeight: offer.offerType !== 'DIGITAL',
        showVariantsWeight,
        showManualStockNotice: (offer.offerType === 'ON_DEMAND' || offer.offerType === 'MOQ') && !adminMode?.isActive,
        showExternalStock: ['SHIP_MONK', 'WHIPLASH_3PL', 'WHIPLASH_FREE', 'CART_JAZZ'].includes(offer.fulfillmentService),
        showSingleSkuInput: !showVariantsTable && values.visualHints.customSkus,
        editable: hasPermission('products.edit.details'),
        variantsEditable: offer.offerType === 'MANUAL',
        stockEditable: adminMode?.isActive ||
            (hasPermission('products.edit.stock') && ['MANUAL', 'DIGITAL'].includes(offer.offerType)),
    };
    const handleVariantTypeAdd = () => {
        navigate(`${reverse(routing.products.all.product.variants, { productId })}?${location.search}`);
    };
    const handleIsCompareAtPriceEnabledValueChange = (value) => {
        if (!value) {
            applyToAllVariants({ compareAtPriceValue: null });
        }
    };
    return (React.createElement(VariantsView, { data: variants, membershipTiers: offer.memberships.tiers, viewConfig: viewConfig, onVariantTypeAdd: handleVariantTypeAdd, onStockChange: handleStockChange, onIsCompareAtPriceEnabledValueChange: handleIsCompareAtPriceEnabledValueChange }));
};
